import { Segmented } from 'antd';
import { CalendarOutlined, AppstoreOutlined } from '@ant-design/icons';

const OPTIONS = [
  { label: 'Semana', value: 'week', icon: <CalendarOutlined /> },
  { label: 'Mes', value: 'month', icon: <AppstoreOutlined /> },
];

const CalendarViewSelector = ({ value, onChange }) => (
  <Segmented options={OPTIONS} value={value} onChange={onChange} />
);

export default CalendarViewSelector;
